/**
 * Custom flowers ("Flowers & Arrangements") ordering rules.
 *
 * Loaded after guided-inquiry-data.js and before guided-inquiry.js. Changes
 * only the 'flowers' category; every other inquiry type is untouched.
 *   - 3 days' (72 hours') minimum notice; Today/Tomorrow removed
 *   - This Week kept, limited to dates in this week that meet the minimum
 *     (hidden when no such date is left this week)
 *   - rush-request message
 *   - "Ask about delivery" (asks for an address or ZIP); pickup preselected
 *   - availability disclaimer; an inquiry does not confirm an order
 */
(function () {
  'use strict';
  var data = window.SDLocalGuidedInquiryData;
  if (!data || !data.categories) return;
  var category = null;
  for (var i = 0; i < data.categories.length; i++) {
    if (data.categories[i].id === 'flowers') category = data.categories[i];
  }
  if (!category || category.customFlowerRules) return;
  category.customFlowerRules = true;

  category.notice = 'Custom arrangement inquiry · Subject to flower availability. Submitting this form does not confirm an order.';
  category.contactOverrides = {
    footnote: 'Specific flower varieties and colors are subject to seasonal and supplier availability. We’ll confirm all details before finalizing your order. Submitting this inquiry does not confirm an order.'
  };

  category.questions = category.questions.map(function (q) {
    if (q.id === 'timing') {
      return {
        id: 'timing',
        label: 'When do you need them?',
        type: 'date-choice',
        minDaysAhead: 3,
        hint: 'Custom arrangements need at least 3 days’ (72 hours’) notice. Need flowers sooner? Contact us directly to check availability. Rush orders may be accommodated.',
        options: [
          { value: 'this_week', label: 'This Week', isDate: true, withinWeek: true, pickerLabel: 'Choose a day this week' },
          { value: 'choose_date', label: 'Choose a Date', isDate: true }
        ]
      };
    }
    if (q.id === 'fulfillment') {
      return {
        id: 'fulfillment',
        label: 'Pickup or delivery?',
        type: 'single',
        defaultOption: 'pickup',
        prefillNote: '{label} is selected. Choose another option if you’d like delivery.',
        hint: 'We’re still setting up delivery zones and pricing, so we’ll confirm delivery options with you.',
        options: [
          { value: 'pickup', label: 'Pickup at SD Local Collective' },
          { value: 'ask_delivery', label: 'Ask about delivery', allowOther: true, otherLabel: 'Delivery address or ZIP code' },
          { value: 'not_sure', label: 'Not Sure' }
        ]
      };
    }
    return q;
  });
})();

/**
 * The "… is selected" note describes the preselected choice only. Hide it
 * when the customer picks a different option on that step (any category).
 * Runs in the capture phase, before the option's own handler updates the
 * selection, so the first click can record which option was preselected.
 */
(function () {
  'use strict';
  if (window.__sdlPrefillNoteFix) return;
  window.__sdlPrefillNoteFix = true;
  document.addEventListener('click', function (event) {
    var target = event.target;
    var btn = target && target.closest ? target.closest('.guided-inquiry__option[data-option]') : null;
    if (!btn) return;
    var viewport = btn.closest('[data-guided-inquiry-viewport]');
    var note = viewport ? viewport.querySelector('.guided-inquiry__hint--prefill') : null;
    if (!note) return;
    if (!note.hasAttribute('data-preselected')) {
      var current = viewport.querySelector('.guided-inquiry__option.is-selected');
      note.setAttribute('data-preselected', current ? current.getAttribute('data-option') : '');
    }
    note.hidden = btn.getAttribute('data-option') !== note.getAttribute('data-preselected');
  }, true);
})();
